export default __webpack_public_path__ + "images/nydree-logo-white@2x.c822c39ae9a601984eee9792bb763c68.png";